import { makeSelectors } from '@utils/css';

const matchSelectors = makeSelectors({
  root: "match--root"
});

export { matchSelectors };
//# sourceMappingURL=_task.match.style.js.map
